import { Component } from '@angular/core';

interface StateData {
  state: string;
  value: string;
}

@Component({
    selector: 'app-regional-transfer-reporting',
    templateUrl: './regional-transfer-reporting.component.html',
    styleUrl: './regional-transfer-reporting.component.scss',
    standalone: true,
    imports: []
})
export class RegionalTransferReportingComponent {
  selectedState: string | null = null;
  data: StateData[] = [
    { state: 'CA', value: 'California Data' },
    { state: 'NY', value: 'New York Data' },
    // Add more data
  ];
  filteredData: StateData[] = [];

  onStateClick(stateId: string) {
    this.selectedState = stateId;
    this.filteredData = this.data.filter(item => item.state === stateId);
    if (this.filteredData.length === 0) {
      console.warn(`No data found for state: ${stateId}`);
    } else {
      console.log(`Clicked ${stateId}:`, this.filteredData);
    }
  }
}

class dispositionData{
  item_type: string;
  manufacture: string;
  state: string;
}